module.exports = __webpack_public_path__ + "img/footer-instagram.3fb7bf98.png";